import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { OfferHttpService } from '../http/offer-http.service';

@Injectable({
    providedIn: 'root',
})
export class VoucherCodeHttpResolverService implements Resolve<any> {
    constructor(private offerHttpService: OfferHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let getVoucherCode = this.offerHttpService.getVoucherCode();
        return getVoucherCode;
    }
}

@Injectable({
    providedIn: 'root',
})
export class DiscountPeriodHttpResolverService implements Resolve<any> {
    constructor(private offerHttpService: OfferHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let getDiscountPeriod = this.offerHttpService.getDiscountPeriod();
        return getDiscountPeriod;
    }
}
